import Image from 'next/image';
import HeaderMobile from './HeaderMobile';
const ContactHeader = () => {
  return (
    <section
      id="call-us"
      className="flex flex-col w-[90%] mx-auto py-5 sm:py-10"
    >
      <h2
        id="call-time"
        className="text-xs sm:text-2xl lg:text-4xl font-semibold text-center text-default"
      >
        Call Anytime From: 8am - 4pm Monday-Friday
      </h2>
      <HeaderMobile />
      <div className="hidden sm:flex justify-center items-center gap-4 text-white mt-5">
        <div className="bg-secondary rounded-[15px] px-6 lg:px-14 py-2">
          <div className="flex flex-col gap-2 items-center">
            <Image
              src="/tollfree_icon.svg"
              width={55}
              height={55}
              alt="toll free"
            />
            <h2 className="sm:text-[22px] lg:text-[28px] font-semibold ">
              Toll Free
            </h2>
            <p className="sm:text-lg lg:text-2xl font-normal">1-888-961-6584</p>
          </div>
        </div>
        <div className="bg-secondary rounded-[15px] px-6 lg:px-14 py-2">
          <div className="flex flex-col gap-2 items-center">
            <Image
              src="/local_icon.svg"
              width={55}
              height={55}
              alt="toll free"
            />
            <h2 className=" text-[16px] sm:text-[22px] lg:text-[28px] font-semibold ">
              Local
            </h2>
            <p className="text-xs sm:text-lg lg:text-2xl font-normal">
              1-289-271-9767
            </p>
          </div>
        </div>

        <div className="bg-secondary rounded-[15px] px-6 lg:px-14 py-2">
          <div className="flex flex-col gap-2 items-center">
            <Image src="/fax_icon.svg" width={55} height={55} alt="toll free" />
            <h2 className="text-[16px] sm:text-[22px] lg:text-[28px] font-semibold">
              Fax
            </h2>
            <p className="text-xs sm:text-lg lg:text-2xl font-normal">
              1-888-908-6056
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHeader;
